import type { CaptureContext } from '@sentry/core';
import * as Sentry from '@sentry/react';

import { SENTRY_DSN, isRNWebview } from 'constants/constants';
import { isOnlineSelector } from 'selectors/tradeSelectors';
import IUser from 'types/IUser';

import StoreProxy from '../storeProxy';
import { trackMixpanelEvent } from './mixpanel-init';

export const addLogsToSentry = (
  userObj: Partial<IUser> | null,
  logEntry: string | Error | object,
  captureContext?: CaptureContext,
  tags?: Record<string, string>
) => {
  const state = StoreProxy.getState();
  const isOnline = isOnlineSelector(state);
  Sentry.withScope(scope => {
    if (userObj) {
      scope.setUser({
        id: userObj.id,
        username: userObj.userName,
        email: userObj.email,
      });
    }
    if (tags) {
      scope.setTags(tags);
    }
    scope.setTag('isOnline', isOnline);
    if (typeof logEntry === 'object') {
      if (logEntry instanceof Error) {
        Sentry.captureException(logEntry, captureContext);
        return;
      }
      Sentry.captureException(new Error(JSON.stringify(logEntry)), captureContext);
    } else {
      Sentry.captureMessage(logEntry, captureContext);
    }
  });
};

export const addLogsInSentryAndMixpanel = (
  userObj: Partial<IUser>,
  title: string,
  captureContext?: CaptureContext
) => {
  trackMixpanelEvent(title, captureContext?.extra ?? {});

  addLogsToSentry(userObj, title, captureContext);
};

export const setLoggedOutInSentry = () => {
  if (!SENTRY_DSN || !Sentry.isInitialized()) return;

  const loggedOutUser = {
    source: isRNWebview() ? 'ReactNative' : 'WebApp',
    userAuthStatus: 'logged-out',
    environment: process.env.REACT_APP_ENV,
  };
  Sentry.setUser(loggedOutUser);
};
